/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name Plus
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTExIDEyLjV2Ny4yNWEuNzUuNzUgMCAwMDEuNSAwVjEyLjVoNy4yNWEuNzUuNzUgMCAwMDAtMS41SDEyLjVWMy43NWEuNzUuNzUgMCAwMC0xLjUgMFYxMUgzLjc1YS43NS43NSAwIDEwMCAxLjV6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:plus
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconPlus = createFondueIcon('Plus', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M11 12.5v7.25a.75.75 0 001.5 0V12.5h7.25a.75.75 0 000-1.5H12.5V3.75a.75.75 0 00-1.5 0V11H3.75a.75.75 0 100 1.5z","clip-rule":"evenodd"}]]);
